import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Heading row for a page section or card: title, optional count and subtitle,
 * with an `[actions]` slot on the right for buttons, toggles or links.
 */
@Component({
    selector: 'app-section-header',
    standalone: true,
    template: `
        <div class="app-section-header__text">
            <h3 class="app-section-header__title" [title]="titleTooltip() || title()">
                @if (icon()) {
                    <i [class]="icon()" aria-hidden="true"></i>
                }
                {{ title() }}
                @if (count() !== null) {
                    <span class="app-section-header__count">{{ count() }}</span>
                }
            </h3>
            @if (subtitle()) {
                <div class="app-section-header__subtitle">{{ subtitle() }}</div>
            }
        </div>
        <div class="app-section-header__actions">
            <ng-content select="[actions]" />
        </div>
    `,
    styleUrl: './section-header.component.scss',
    host: { class: 'app-section-header', '[attr.data-level]': 'level()' },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionHeaderComponent {
    title = input.required<string>();
    /** Hover text for the title, e.g. the legacy name of a renamed concept. */
    titleTooltip = input<string | null>(null);
    subtitle = input<string | null>(null);
    icon = input<string | null>(null);
    count = input<number | null>(null);
    level = input<'page' | 'section'>('section');
}
